// Dependency-free (touches only globalThis.localStorage). main.tsx imports this
// as its FIRST JS import so the purge runs at module-eval time, BEFORE the app
// module graph (@web/core → … → data/services/index.ts) evaluates. The services
// barrel builds Cognito at import and throws when VITE_COGNITO_* is unset; a
// purge in main's async body would never run in that case. See spec §3.
//
// TOKENS_KEY/OIDC_USER_PREFIX are FROZEN LEGACY localStorage keys the old bundle
// wrote before this hardening branch moved live tokens to sessionStorage. They
// are intentionally duplicated here rather than imported from auth_tokens.ts —
// new code never writes localStorage — so a future rename of the live
// sessionStorage keys in auth_tokens.ts must NOT touch these literals.
const TOKENS_KEY = 'voll.auth.tokens';
const OIDC_USER_PREFIX = 'voll.auth.user.';

export function purgeLegacyAuthStorage(storage: Storage = globalThis.localStorage): void {
  storage.removeItem(TOKENS_KEY);
  for (let i = storage.length - 1; i >= 0; i -= 1) {
    const key = storage.key(i);
    if (key?.startsWith(OIDC_USER_PREFIX)) storage.removeItem(key);
  }
}

purgeLegacyAuthStorage();
